import React from "react";
import { VStack } from "@astryxdesign/core";
import styles from "./PageContainer.module.css";

export interface PageContainerProps {
  children: React.ReactNode;
}

/**
 * Astryx-native page frame — a Theme-driven container for page layouts.
 *
 * Structure is an Astryx VStack (flex column); background and foreground come
 * from Astryx neutral-theme tokens, so this MUST be rendered inside an Astryx
 * <Theme> scope. Use this as the standard page container for new Astryx-themed pages.
 *
 * For legacy pages not yet migrated to Astryx, use LegacyPageContainer.
 */
const PageContainer = ({
  children,
}: PageContainerProps): React.ReactElement => {
  return (
    <VStack className={styles.frame} align="stretch" gap={0}>
      {children}
    </VStack>
  );
};

export default PageContainer;
